<template>
    <div id="pcVehicelDescriptionPageWrapperDiv">
        <div v-if="shareFormOpen">
            <vehicle-image-share/>
        </div>

        <div id="vehicleDescriptionActionBar">
            <div id="vehicleDescriptionActionEllementsDiv">
                <div id="backToFiltersButton" @click="closeGallery">
                    &lt; Back
                </div>
            </div>
        </div>

        <div id="vehicleDescriptionDisplayDiv">
            <div id="vehicleDescriptionPageTop">
                <vehicle-image-gallery/>
                <div id="vehicleDisplayInformationSection" :class="[showThumbnails ? 'withThumbnails' : '']">
                    <div id="vehicleDisplayTitleDiv">
                        <div id="yearMakeModelTrimDiv" @click="openShareForm">
                            <div class="carYear">
                                {{ vehicle.Year }}&nbsp;
                            </div>
                            <div class="carMake">
                                {{ vehicle.Make }}&nbsp;
                            </div>
                            <div class="carModel carTitle">
                                {{ vehicle.Model }}&nbsp;
                            </div>
                            <div v-if="vehicleTrimExists()">
                                {{ vehicle.VehicleTrim }}
                            </div>
                        </div>
                        <div class="stockNumberDiv">
                            <div v-if="!$store.getters.isLoggedIn">
                                {{ vehicle.StockNumber }} 
                            </div>
                            <div v-else class="LoggedIn" @click="openAuctionPage(vehicle.AuctionPage)">
                                {{ vehicle.StockNumber }} 
                                <span class="vinDisplay">
                                    {{ vehicle.VIN }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div id="vehicleInformationAndActionDiv">
                        <div id="vehicleDisplayInformationDiv">
                            <div id="vehicleInformationDataDiv">
                                <div class="vehicleDataPoint mobileCarPrice" @click="goToProposalLink">
                                    {{ priceTitle }}: {{ formatNumber(vehicle['PriceToShow'], 'PriceToShow') }}
                                </div>
                                <div class="vehicleDataPoint mobileCarMiles">
                                    Mileage: {{ formatNumber(vehicle['Miles'], 'Miles') }}
                                </div>
                                <div class="vehicleDataPoint mobileCarAcv" v-if="$store.getters.isLoggedIn">
                                    ACV includes PAC: {{ formatNumber(vehicle['ACV'], 'ACV') }}
                                </div>
                                <div class="vehicleDataPoint mobileCarBob" v-if="$store.getters.isLoggedIn" >
                                    Back of Book includes PAC:
                                    <span :class="[negativeBOB(vehicle['BOB']) ? 'negativeValue' : '']">
                                        {{ formatNumber(vehicle['BOB'], 'BOB') }}
                                    </span>
                                </div>
                                <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.EngineSize)">
                                    Engine: {{ vehicle.EngineSize }}
                                </div>
                                <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.Transmission)">
                                    Transmission: {{ vehicle.Transmission }}
                                </div>
                                <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.Drive)">
                                    Drivetrain: {{ vehicle.Drive }}
                                </div>
                                <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.ExteriorColor)">
                                    Exterior Color: {{ vehicle.ExteriorColor }}
                                </div>
                                <div class="vehicleDataPoint" v-if="informationAvailable(vehicle.InteriorColor)">
                                    Interior Color: {{ vehicle.InteriorColor }}
                                </div>
                                <div class="vehicleDataPoint">
                                    Options: {{ formatOptions() }}
                                </div>
                            </div>
                        </div>
                        <div id="startDealButton" class="top">
                            <cta-button class="vdpAction"/>
                            <crash-mark :crashedCar="vehicle" page="vdp" v-if="$store.getters.isLoggedIn"/>
                        </div>
                    </div>
                </div>
            </div>
            <autocheck-doc/>
            <div id="callToActionFooter">
                <div id="startDealButton" class="bottom">
                    <cta-button class="vdpAction"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VehicleImageShare from './SendPicturesForm.vue';
    import CallToActionButton from './CallToActionButtons.vue';
    import AutoCheckDoc from './Autocheck.vue';
    import VehicleImageGallery from './VehicleImageGallery.vue';
    import CrashMark from './CrashMark.vue';

    export default {
        components: {
            'vehicle-image-share': VehicleImageShare,
            'cta-button': CallToActionButton,
            'autocheck-doc': AutoCheckDoc,
            'vehicle-image-gallery': VehicleImageGallery,
            'crash-mark': CrashMark
        },
        computed: {
            vehicle() {
                return this.$store.getters.vehicleGallerySelected;
            },
            shareFormOpen() {
                return this.$store.getters.isVehicleShareFormOpen;
            },
            priceTitle() {
                return this.$store.getters.isLoggedIn ? "Price includes PAC" : "Price";
            },
            proposalLink() {
                return this.$store.getters.getAppUrlByName('mycar') + "/component/textProposal/" + this.vehicle['StockNumber'];
            }
        },
        methods: {
            openShareForm() {
                this.$gtag.event('open', {'event_category': 'send_pictures'});
                this.$store.commit('setVehicleShareFormOpen', true);
            },
            closeGallery() {
                this.$gtag.event('close', {'event_category': 'vehicle_gallery'});
                this.$store.commit('setVehicleGallerySelected', null);
                this.$store.commit('setOpenGalleryImages', []);
            },
            formatNumber: function (num, type) {
                var numFormated = "";
                
                if(num) {
                    if(type == 'PriceToShow' || type == 'ACV' || type == 'BOB') {
                        numFormated = "$";
                    } 
                    
                    numFormated += num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

                    if(type == 'BOB' && num < 0) {
                        numFormated = "(" + numFormated.replace('-', '') + ")";
                    }
                }
                else {
                    numFormated = 0;
                }
                
                return numFormated;
            },
            negativeBOB(num) {
                let negative = false;
                
                if (num && num < 0) {
                    negative = true;
                }
                
                return negative;
            },
            informationAvailable(infoValue) {
                let available = false;

                if(infoValue) {
                    if(!['N/A','Unspecified','None'].includes(infoValue)) {
                        available = true;
                    }
                }

                return available;
            },
            formatOptions() {
                let optionsList = ""

                if(this.vehicle.Moonroof && this.vehicle.Moonroof == 1) {
                    optionsList += (optionsList ? ", ": "") + "Moonroof";
                }

                if(this.vehicle.RearEntertainment) {
                    optionsList += (optionsList ? ", " : "") + 'Rear Entertainment';
                }

                if(this.vehicle.Nav && this.vehicle.Nav == 1) {
                    optionsList += (optionsList ? ", " : "") + "Navigation";
                }

                if(this.vehicle.Leather && this.vehicle.Leather == 1) {
                    optionsList += (optionsList ? ", " : "") + "Leather";
                }

                if(this.vehicle.bcamera && this.vehicle.bcamera == 1) {
                    optionsList += (optionsList ? ", " : "") + "Backup Camera";
                }

                if(this.vehicle.CabType && this.vehicle.CabType != "None") {
                    optionsList += (optionsList ? ", " : "") + this.vehicle.CabType;
                }

                if(this.vehicle.thirdrow && this.vehicle.thirdrow == 1) {
                    optionsList += (optionsList ? ", " : "") + "Third Row";
                }

                if(this.vehicle.Doors && this.vehicle.Doors != "N") {
                    optionsList += (optionsList ? ", " : "") + this.vehicle.Doors + " Door";
                }

                return optionsList;
            },
            openAuctionPage(auction_page) {
                this.$gtag.event('open', {'event_category': 'auction_page','event_label': 'mobile'});
                this.$store.dispatch('openAppInSeperateWindow', auction_page);
            },
            vehicleTrimExists() {
                return (this.vehicle.VehicleTrim && this.vehicle.VehicleTrim != 'None');
            },
            showThumbnails() {
                return this.$store.getters.isLoggedIn && this.$store.getters.getOpenGalleryImages > 0;
            },
            goToProposalLink() {
                console.log("GOTO PROPOSAL LINK");
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'text_proposal_from_vdp','event_label': eventLabel});
                this.$store.dispatch('openAppInSeperateWindow', this.proposalLink);
            }
        }
    }
</script>

<style scoped>
    #pcVehicelDescriptionPageWrapperDiv {
        position: absolute;
        height: calc(85 * var(--vh));
        width: calc(100 * var(--vw));
        top: calc(12 * var(--vh));
        left: 0;
    }

    #vehicleDescriptionActionBar {
        width: 100%;
        height: calc(5 * var(--vh));
        font-family: arial, sans-serif;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em));
        font-weight: bolder;
        color: white;
        background: #2B2A2B;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    #vehicleDescriptionActionEllementsDiv {
        width: calc(90 * var(--vw));
        height: inherit;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    #backToFiltersButton {
        cursor: pointer;
    }

    #startDealButton {
        height: calc((6 * var(--vh)) + (4 * var(--vw)));
        width: calc(56 * var(--vw));
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .withThumbnails #startDealButton {
        width: calc(50 * var(--vw));
    }

    #startDealButton.bottom {
        height: inherit;
        justify-content: center;
    }

    #startDealButton .vdpAction {
        width: calc(32 * var(--vw));
        min-width: fit-content;
        height: calc(6 * var(--vh));
        font-size: calc(2.75 * var(--vh));/*2.8em;*//*1.5em;*/
        margin: 0 calc((2 * var(--vw)) - (1.2 * var(--vh)));
        margin-top: 0;
        border-radius: calc(var(--vratio) * var(--vw));
    }

    #startDealButton:hover {
        border-color: var(--mccluskeyGold); /*#AF873F;*/
        color: black;
    }

    #vehicleDescriptionDisplayDiv {
        width: inherit;
        height: calc(80 * var(--vh));
        overflow-y: scroll;
    }

    #vehicleDescriptionPageTop {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: calc((((40 / 4) * 3) * var(--vw)) + (4 * var(--vw)));
    }

    #vehicleDisplayInformationSection {
        height: inherit;
        width: calc(56 * var(--vw));
        display: flex;
        flex-direction: column;
        background: white;
        color: black;
    }

    #vehicleDisplayInformationSection.withThumbnails  {
        width: calc(50 * var(--vw));
    }

    #vehicleDisplayTitleDiv {
        width: inherit;
        height: calc(10 * var(--vh));
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        display: flex;
    }

    #vehicleDisplayInformationDiv {
        width: calc(56 * var(--vw));
        height: calc((((((40 / 4) * 3) * var(--vw)) + (4 * var(--vw))) - (10 * var(--vh))) - ((6 * var(--vh)) + (4 * var(--vw)))); /*fit-content;*/
        max-height: calc((((((40 / 4) * 3) * var(--vw)) + (4 * var(--vw))) - (10 * var(--vh))) - ((6 * var(--vh)) + (4 * var(--vw))));
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .withThumbnails #vehicleDisplayInformationDiv {
        width: calc(50 * var(--vw));
    }

    #vehicleInformationDataDiv {
        margin: calc((2 * var(--vw)) - (1.2 * var(--vh)));
        height: fit-content;
        max-height: inherit;
        text-align: left;
        font-weight: normal;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }

    .withThumbnails #vehicleInformationDataDiv {
        padding-left: calc((2 * var(--vw)) - (1.2 * var(--vh)));
    }

    #vehicleInformationAndActionDiv {
        height: calc(((((40 / 4) * 3) * var(--vw)) + (4 * var(--vw))) - (10 * var(--vh)));
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }

    .stockNumberDiv {
        margin: 0 calc(2 * var(--vw));
        width: calc((56 * var(--vw)) - (4 * var(--vw)));
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        font-size: calc((.8 * var(--vw)) + ((var(--vratio) - .5) * 1em));
    }

    .withThumbnails .stockNumberDiv { 
        width: calc((50 * var(--vw)) - (4 * var(--vw)));
    }

    .stockNumberDiv > .LoggedIn {
        color: var(--mccluskeyBlue); /*#0077C0;*/ /*#0079B6;*/
        cursor: pointer;
    }

    .vinDisplay {
        margin: 0 calc(2 * var(--vh));
    }

    #yearMakeModelTrimDiv {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: calc((1.5 * var(--vw)) + ((var(--vratio) - .5) * 1em));
        margin: 0 calc(2 * var(--vw));
        cursor: pointer;
    }

    #modelAndTrimDiv {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        color: black;
        /*font-size: calc((1.5 * var(--vw)) + ((var(--vratio) - .5) * 1em));*/
    }

    #vehicleInformationDiv {
        text-align: left;
        overflow-y: scroll;
    }

    ::-webkit-scrollbar {
        width: 0px;  /* remove scrollbar space */
        background: transparent;  /* optional: just make scrollbar invisible */
    }

    .mobileCarDetails {
        width: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(4 * var(--vh));
    }

    .vehicleDataPoint {
        margin: 0 calc(1.2 * var(--vh)) calc(1.2 * var(--vh));
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em));
    }

    .withThumbnails .vehicleDataPoint {
        margin: 0 calc(1.2 * var(--vh)) calc(1.2 * var(--vh)) 0;
        width: calc(((50 * var(--vw)) - (4 * (1.2 * var(--vh)))) / 2);
        overflow-wrap: break-word;
        height: fit-content;
    }

    #callToActionFooter {
        background-color: white;
        height: calc(10 * var(--vh));
        width: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .negativeValue {
        color: red;
    }
</style>
